export interface FileErrors {
  invalidFileType?: boolean;
  maxFileSize?: boolean;
}

export interface FileValidationResult {
  isValid: boolean;
  errors: FileErrors | null;
}

export function validateImageFile(file: File, maxSizeMB = 4): FileValidationResult {
  const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  const errors: FileErrors = {};

  if (!allowedTypes.includes(file.type)) {
    errors.invalidFileType = true;
  }

  if (file.size > maxSizeBytes) {
    errors.maxFileSize = true;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors: Object.keys(errors).length ? errors : null
  };
}